// https://stackoverflow.com/a/26191207
const currentWidth = () => window.innerWidth && document.documentElement.clientWidth ?
  Math.min(window.innerWidth, document.documentElement.clientWidth) :
  window.innerWidth ||
    document.documentElement.clientWidth ||
    document.getElementsByTagName('body')[0].clientWidth

const currentHeight = () => window.innerHeight && document.documentElement.clientHeight ?
  Math.min(window.innerHeight, document.documentElement.clientHeight) :
  window.innerHeight ||
    document.documentElement.clientHeight ||
    document.getElementsByTagName('body')[0].clientHeight

export {
  currentWidth,
  currentHeight,
}
